'use client';
import { Description, Root, Title } from '@radix-ui/react-dialog';
import { PropsWithChildren, useEffect } from 'react';
import './styles.css';
import { removeBodyScrollbar } from '@/utils/helpers';

type Props = PropsWithChildren & {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export default function DatePickerRoot({
  open,
  onOpenChange,
  children,
}: Props) {
  useEffect(() => {
    removeBodyScrollbar(open);
  }, [open]);

  return (
    <Root open={open} onOpenChange={onOpenChange}>
      <Title className="hidden" />
      <Description className="hidden" />
      {children}
    </Root>
  );
}
